import "./navBar.css";
import { Link } from "react-router-dom";
import LOGO from "./TicketsLK Logo White 1.svg";
import whatsappLogo from "./Whatapp Icon.svg";

const NewNavBar = () => {
  return (
    <>
      <nav className="primaryNavigation flexB">
        <Link to="/">
          <img className="mainLogo" src={LOGO} alt="" />
        </Link>
        <div className="navPage flexB">
          <Link to="/">Home</Link>
          <Link to="/movies">Movies</Link>
          <Link to="/events">Events</Link>
          <Link to="/contact">Contact Us</Link>
          <button
            onClick={() =>
              window.open("https://api.whatsapp.com/send?phone=94776303456")
            }
          >
            <img src={whatsappLogo} alt="WhatApp" />
          </button>
        </div>
      </nav>
    </>
  );
};

export default NewNavBar;
